import type { ApiOwnRsvp } from '#/modules/listing/events/api/types/ApiRsvpResponse';
import { postJson } from '#/utils/http/postJson';

export type RegisterForEventPayload = {
  firstName: string;
  lastName: string;
  email: string;
  gRecaptchaResponse?: string;
};

type ApiResponse = {
  ownRsvp: ApiOwnRsvp;
};

export function listingApiRegisterForEvent(
  eventId: string,
  payload: RegisterForEventPayload,
): Promise<ApiResponse> {
  return postJson<ApiResponse>(`/data/website/events/${eventId}/rsvp`, payload);
}
